import { useState } from 'react';
import useAPI from '../../../../hooks/useAPI';

export const GENERAL_DATA_FILTERS = {
  USER: 'user',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  MBA: 'mba',
  PRO: 'pro',
  DOC: 'doc',
  PAID: 'paid',
  MC: 'mc',
  PPA: 'ppa',
  TRAILS: 'trails'
}

const buildGeneralDataURL = ({ baseUrl, filters, page, rowsPerPage}) => {
  const query = {
    page: page + 1,
    limit: rowsPerPage,
    ...(filters?.[GENERAL_DATA_FILTERS.USER] && {search: filters[GENERAL_DATA_FILTERS.USER],}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.MBA] !== 'undefined' && {isMba: filters[GENERAL_DATA_FILTERS.MBA]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.PAID] !== 'undefined' && {isPaying: filters[GENERAL_DATA_FILTERS.PAID]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.MC] !== 'undefined' && {isMC: filters[GENERAL_DATA_FILTERS.MC]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.PPA] !== 'undefined' && {isPPA: filters[GENERAL_DATA_FILTERS.PPA]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.TRAILS] !== 'undefined' && {isTrail: filters[GENERAL_DATA_FILTERS.TRAILS]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.PRO] !== 'undefined' && {isPro: filters[GENERAL_DATA_FILTERS.PRO]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.DOC] !== 'undefined' && {isDoc: filters[GENERAL_DATA_FILTERS.DOC]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.START_DATE] !== 'undefined' && {date_initial: filters[GENERAL_DATA_FILTERS.START_DATE]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.END_DATE] !== 'undefined' && {date_end: filters[GENERAL_DATA_FILTERS.END_DATE]}),
    ...(typeof filters?.[GENERAL_DATA_FILTERS.PAID] !== 'undefined' && {isPaying: filters[GENERAL_DATA_FILTERS.PAID]}),
  }

  const queryParams = new URLSearchParams(query);

  return `${baseUrl}?${queryParams.toString()}`
}

export default function useGeneralData({ startDate, endDate }) {
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({
    ...(startDate && {[GENERAL_DATA_FILTERS.START_DATE]: startDate}),
    ...(endDate && {[GENERAL_DATA_FILTERS.END_DATE]: endDate}),
  });

  const { data, isLoading, refreshData } = useAPI(buildGeneralDataURL({ baseUrl: `/admin/table-customer-success-v2`, filters, page, rowsPerPage }));

  const changeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  }

  const changeFilters = (filters) => {
    setFilters(filters);
    setPage(0);
  }

  const resetFilters = () => {
    changeFilters({
      ...(startDate && {[GENERAL_DATA_FILTERS.START_DATE]: startDate}),
      ...(endDate && {[GENERAL_DATA_FILTERS.END_DATE]: endDate}),
    });
  }

  const changePage = (newPage) => {
    setPage(newPage);
  }

  return {
    data,
    isLoading,
    rowsPerPage,
    page,
    filters,
    changeFilters,
    resetFilters,
    changeRowsPerPage,
    changePage,
    refreshData
  };
}